module.exports = __webpack_public_path__ + "img/CyberLabCert.9da78a3a.png";